import * as AnalyticAppColor from 'common/constants/analytic-app-color';
import {t} from 'common/utils/translation-util';

export const NONE = {
  color: AnalyticAppColor.GRAY,
  displayName: t('None'),
  slug: 'none',
};
export const DEFAULT = {
  color: AnalyticAppColor.GRAY,
  displayName: t('None'),
  slug: 'none',
};
export const PREVIOUS = {
  color: AnalyticAppColor.GRAY,
  displayName: t('Previous period'),
  slug: 'previous',
};
export const LAST = {
  color: AnalyticAppColor.GRAY,
  displayName: t('Same day last week'),
  slug: 'last',
};
export const FORECAST = {
  color: AnalyticAppColor.BLUE,
  displayName: t('Forecast'),
  slug: 'forecast',
};
export const BASELINE = {
  color: AnalyticAppColor.BLUE,
  displayName: t('Baseline'),
  slug: 'baseline',
};
export const TEMPERATURE = {
  color: AnalyticAppColor.LAVENDER,
  displayName: t('Outdoor temperature'),
  slug: 'temperature',
};
export const CDD = {
  color: AnalyticAppColor.LIGHT_BLUE,
  displayName: t('Cooling degree days'),
  slug: 'cdd',
};
export const HDD = {
  color: AnalyticAppColor.PAPAYA,
  displayName: t('Heating degree days'),
  slug: 'hdd',
};
export const METER = {
  color: AnalyticAppColor.GREEN,
  displayName: t('Point'),
  slug: 'meter',
};
